import { Stage } from '../types/stages';
import { getRandomElementFromArray } from './arrays';
import {
  names,
  vehicles,
  statuses,
  notifications,
  stages,
  messages,
  carImages,
  carModels,
  carColors,
  carStatuses,
  userImages,
  roles,
  hosts,
} from './mocks';

export const generateRandomString = (length: number) =>
  Array(length + 1)
    .join(`${Math.random().toString(36)}${new Date().getTime()}`.slice(2, 18))
    .slice(0, length)
    .toUpperCase();
export const generateRandomName = () => getRandomElementFromArray(names);
export const generateRandomVehicle = () => getRandomElementFromArray(vehicles);
export const generateRandomStatus = () => getRandomElementFromArray(statuses);
export const generateRandomNotification = () => getRandomElementFromArray(notifications);
export const generateRandomStage = () => getRandomElementFromArray(stages) as Stage;
export const generateRandomMessage = () => getRandomElementFromArray(messages);
export const generateRandomDate = (from: Date, to: Date): Date => {
  const fromUnix = from.getTime();
  const toUnix = to.getTime();
  return new Date(fromUnix + Math.random() * (toUnix - fromUnix));
};
export const generateRandomNumber = (from: number, to: number): number => {
  return Math.floor(Math.random() * (to - from + 1)) + from;
};
export const generateRandomCarImage = () => getRandomElementFromArray(carImages);
export const generateRandomCarModel = () => getRandomElementFromArray(carModels);
export const generateRandomCarColor = () => getRandomElementFromArray(carColors);
export const generateRandomCarStatus = () => getRandomElementFromArray(carStatuses);
export const generateRandomUserImage = () => getRandomElementFromArray(userImages);
export const generateRandomRole = () => getRandomElementFromArray(roles);
export const generateRandomHost = () => getRandomElementFromArray(hosts);
export const generateEmail = (name: string) =>
  `${name.split(' ').join('').toLocaleLowerCase()}@${generateRandomHost()}.com`;
export const generateRandomBoolean = () => !!generateRandomNumber(0, 1);

export const getGreetingMessage = () => {
  const today = new Date();
  const hours = today.getHours();
  return (hours < 12 && 'Good Morning') || hours < 18 ? 'Good Afternoon' : 'Good Evening';
};

// it formats currency by passing isoCode, currency and value
export const currencyFormat = (value: any, currency: string, isoCode: string) => {
  const formatter = new Intl.NumberFormat(`en-${isoCode}`, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  });
  const formattedValue = formatter.format(value);
  return formattedValue !== '$NaN' ? formattedValue : '--';
};

export const numToWords: any = (n: any) => {
  const a: any = [
    '',
    'First',
    'Second',
    'Third',
    'Forth',
    'Fifth',
    'Sixth',
    'Seventh',
    'Eighth',
    'Ninth',
    'Tenth',
    'Eleventh',
    'Twelfth',
    'Thirteenth',
    'Fourteenth',
    'Fifteenth',
    'Sixteenth',
    'Seventeenth',
    'Eighteenth',
    'Nineteenth',
    'Twenty',
  ];
  const b: any = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  const g: any = [
    '',
    'thousand',
    'million',
    'billion',
    'trillion',
    'quadrillion',
    'quintillion',
    'sextillion',
    'septillion',
    'octillion',
    'nonillion',
  ];
  const arr = (x: any) => Array.from(x);
  const num = (x: any) => Number(x) || 0;
  const str = (x: any) => String(x);
  const isEmpty = (xs: any) => xs.length === 0;
  const take = (ns: any) => (xs: any) => xs.slice(0, ns);
  const drop = (ns: any) => (xs: any) => xs.slice(ns);
  const reverse = (xs: any) => xs.slice(0).reverse();
  const comp: any =
    (f: any): any =>
    (gg: any): any =>
    (x: any): any =>
      f(gg(x));
  const not = (x: any) => !x;
  const chunk: any =
    (ns: any): any =>
    (xs: any): any =>
      isEmpty(xs) ? [] : [take(ns)(xs), ...chunk(ns)(drop(ns)(xs))];
  // this part is really nasty still
  // it might edit this again later to show how Monoids could fix this up
  const makeGroup = ([ones, tens, huns]: any) => {
    return [
      num(huns) === 0 ? '' : `${a[huns]} hundred`,
      num(ones) === 0 ? b[tens] : (b[tens] && `${b[tens]} -`) || '',
      a[tens + ones] || a[ones],
    ].join('');
  };
  // "thousands" constructor; no real good names for this, i guess
  const thousand = (group: any, i: number) => (group === '' ? group : `${group} ${g[i]}`);
  // execute !
  if (typeof n === 'number') return numToWords(String(n));
  if (n === '0') return 'zero';
  return comp(chunk(3))(reverse)(arr(n)).map(makeGroup).map(thousand).filter(comp(not)(isEmpty)).reverse().join(' ');
};

export const generateRandomColor = () => {
  const rnd = Math.floor(Math.random() * 16777215).toString(16);
  return `#${rnd}`;
};
